export const Features = [
  {
    name: "Accesso a tutti i workouts",
    description: "Ottieni l'accesso completo a tutti gli allenamenti.",
    free: false,
    premium: true,
  },
  {
    name: "Accesso a tutti gli esercizi",
    description: "Accesso completo ai tutorial per tutti gli esercizi.",
    free: false,
    premium: true,
  },
  {
    name: "Gestione completa del profilo",
    description: "Gestisci tutti i tuoi dati e le tue attività.",
    free: false,
    premium: true,
  },
  {
    name: "Gestione crescità skills personali",
    description: "Tieni traccia di tutti i tuoi progressi.",
    free: false,
    premium: true,
  },
];